import styled from 'styled-components';
import { loginTheme } from '../../../theme/loginTheme';

// note: leaving empty styled component for future logo styling ||
// we can also use logo wrapper with position:absolute as a additional component on the page
// for example, we can throw a video here
const LogoWrapper = styled.div``;

// Login chrome is pinned to loginTheme so the app light/dark toggle cannot restyle it.
const SignInHeader = styled.div`
  cursor: default;
  position: relative;
  
  h2 {
    font-size: 20px;
    line-height: 27px;
  }
  
  p {
    color: ${loginTheme.colors.inactive};
    line-height: 18px;
    font-size: 13px;
  }
`;

const FooterWrapper = styled.div`
  padding-bottom: 24px;

  .forgot-password-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    min-height: 34px;
    margin-top: -34px;
  }

  button {
    font-size: 13px;
    color: ${loginTheme.colors.main_cta};
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;

    :hover {
      color: ${loginTheme.colors.text};
    }
  }

  .footer-meta {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 16px;
  }

  .app-version,
  .terms {
    margin: 0;
    font-size: 13px;
    line-height: 18px;
    color: ${loginTheme.colors.inactive};
    cursor: default;
  }

  .terms span {
    cursor: pointer;
    color: ${loginTheme.colors.main_cta};
  }
`;

const ResetPasswordHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  h2 {
    margin: 0;
    font-size: 20px;
    line-height: 27px;
  }

  button {
    font-size: 13px;
    color: ${loginTheme.colors.main_cta};
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    white-space: nowrap;

    :hover {
      color: ${loginTheme.colors.text};
    }
  }
`;

export {
  LogoWrapper, SignInHeader, FooterWrapper, ResetPasswordHeaderWrapper,
};
